module.exports = __webpack_public_path__ + "img/thumbnail-satellite-feetscare.d75f6081.webp";